export default function initSubmenuToggle() {
  const isPresent = document.querySelector("[data-toggle-submenu]");
  if (!isPresent) {
    return;
  }

  const toggles = document.querySelectorAll("[data-toggle-submenu]");

  toggles.forEach((el) => {
    el.addEventListener("click", function () {
      el.classList.toggle("active");

      const target = el.nextElementSibling;

      if (target.classList.contains("hidden")) {
        target.classList.remove("hidden");
      } else {
        target.classList.add("hidden");
      }
    });
  });
}
